<!-- <div class="first-row w-100">
    <div class="col-2">
        <p id="listoftrainings">Skills</p>
    </div>
    <div class="search-text col-1">

    </div>
    <div class="col-6 addtools">
        <div class="roles-dropdown">
            <span>Proficiency:</span>
            <select class="form-control filter-role" (change)="onProficiencyChange($event.target.value)">
                <option *ngFor="let p of proficiency" [value]="p.key">{{p.value}}
                </option>
            </select>
        </div>
        <div class="roles-dropdown">
            <span>Skill:</span>
            <select class="form-control filter-role" (change)="onSkillChange($event.target.value)">
                <option *ngIf="skills.length === 0" value="">Not Available</option>
                <option *ngFor="let p of skills" [value]="p.skill">{{p.skill}}
                </option>
            </select>
        </div> 
    </div>
    <div class="col-3" >
    <button class="create-training btn custom_btn primary_btn_base col">
    <i class="fa fa-plus-circle  "></i>
    Initiate Training
  </button>
</div>
</div> -->
<div class="first-row w-100 ">
    <div class="col-2">
      <p id="listoftrainings"> </p>
    </div>
    <div class="search-text col-7">
      <div class="icon">
        <span class="material-symbols-outlined">
           
        </span>
      </div>
      <div class="w-75">
        <input type="search" class="search" id="search-text" aria-describedby="search-text"
           placeholder="Search for skills,employee IDs, employee names or email addresses " [(ngModel)]="searchTerm" (ngModelChange)="onValueChange()">
      </div>
    </div>
    <div class="col-1 "  matTooltipPosition="above"> 
          <button  matTooltip="Advanced Filters" matTooltipPosition="above" class="advFilter"
           >
           <i class="fa fa-filter" aria-hidden="true"></i>
      </button>
    </div>
    <div class="col-2 addtools">
         
      <button (click)="initiateTraining()" class="custom_btn primary_btn_base col">
        <i class="fa fa-graduation-cap" aria-hidden="true"></i>&nbsp;
        Initiate Training
      </button> 
    </div>

  </div>
<div class="total w-100 topMarigin">
    <table  mat-table [dataSource]="dataSource" matSort class="SkillTable">
        <!--  Columns -->
          
        
<ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef mat-sort-header class="alignment">
    <mat-checkbox class="htmlCheckBox" (ngModelChange)="masterToggle($event)"
    [(ngModel)]="isAllSelected"
     [indeterminate]="isIndeterminate()">
    </mat-checkbox>    
    </th>
    <td mat-cell *matCellDef="let row"> 
    <mat-checkbox class="htmlCheckBox" (click)="$event.stopPropagation();"
    [(ngModel)]="row.isChecked" 
    (ngModelChange)="storeSelectedIds(row,$event);"
    [value]="row.employeeId">
    </mat-checkbox>
    </td>
    </ng-container> 
        <ng-container matColumnDef="employeeId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="alignment">Employee Id</th>
            <td mat-cell *matCellDef="let row" class="">
                {{row.employeeId}} </td>
        </ng-container>
        <ng-container matColumnDef="firstName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>FirstName</th>
            <td mat-cell *matCellDef="let row">
                {{row.firstName}} </td>
        </ng-container>

        <ng-container matColumnDef="lastName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>LastName</th>
            <td mat-cell *matCellDef="let row">{{row.lastName}} </td>
        </ng-container>

        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
            <td mat-cell *matCellDef="let row"> {{row.email}} </td>
        </ng-container>
        <ng-container matColumnDef="primarySkillsData">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Skills </th>
            <td mat-cell *matCellDef="let row"> {{row.primarySkillsData}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row [class.odd]="i % 2 == 1" [class.even]="i % 2 == 0" *matRowDef="let row; columns: displayedColumns;let i = index;"></tr>
        <!-- Row shown when there is no matching data. -->

    </table>
    <mat-paginator [length]="totalRecords"  [pageSize]="10" [pageSizeOptions]="[10,25,50,100]" aria-label="Select page"
    (page)="getPaginatorData($event)" class="Pagination"></mat-paginator>
    <!-- <div class="pagination">
        <button mat-button class="pagination-button" [disabled]="currentPage === 1">
            <mat-icon>chevron_left</mat-icon>
        </button>

        <div class="page-numbers">
            <button mat-button class="pagination-button" *ngFor="let page of [1,2,3]"
                [class.active]="page === currentPage" (click)="onPageButtonClick(page)" [ngStyle]="{
                        'color': page === currentPage ? 'white' : 'black'
                      }">{{ page }}</button>
        </div>

        <button mat-button class="pagination-button" [disabled]="currentPage === 1">
            <mat-icon> chevron_right </mat-icon>
        </button>
    </div> -->
</div>